<!-- Start Main Banner Area -->
<div class="main-banner">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container-fluid">
                <div class="row align-items-center">
                    <div class="col-lg-6 col-md-12">
                        <div class="main-banner-content">
                            <h1>
                                <span style="color: rgb(133, 255, 0)"
                                    >啟動數位</span
                                ><span
                                    style="
                                        color: rgb(14, 207, 243);
                                        text-indent: 0px;
                                        white-space: nowrap;
                                    "
                                    >新未來</span
                                >
                            </h1>
                            <br />
                            <span
                                >Empowering the Next Transformation with the
                                Future</span
                            >
                            <br />
                            <p>
                                當商業模式開始改變，市場驅動變革，數位轉型勢不可擋，傳統孤島式資訊導入，成為未來布局的絆腳石，碩達系統以實踐企業藍圖下一步為主導的策略規劃，建立新生態系統的橋樑，串聯現有技術與新興科技，建構
                                IT
                                加值服務、重塑數據賦能決策，協助企業奠定未來，探索新商業模式
                            </p>
                            <p>
                                It’s what you do right now that makes a
                                difference. ──"Black Hawk Down"
                            </p>
                            <!-- <a href="#" class="btn btn-primary">Get Started</a> -->
                        </div>
                    </div>

                    <div class="col-lg-6 col-md-12" style="padding-right: 0px">
                        <div class="main-banner-image">
                            <!-- <img src="assets/img/main/pic_09.png" alt="image" /> -->
                            <img
                                src="assets/img/main/pic09_a.png"
                                alt="image"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- <div class="banner-shape"><img src="assets/img/white-shape.png" alt="image"></div> -->
    <!-- <div class="shape1"><img src="assets/img/shape/2.png" alt="image"></div>
    <div class="shape2"><img src="assets/img/shape/3.png" alt="image"></div> -->
</div>
<!-- End Main Banner Area -->

<!-- Start Partner Area -->
<!-- <div class="partner-area">
    <div class="container">
        <div class="partner-slides owl-carousel owl-theme">
            <div class="single-partner-item">
                <a href="#"><img src="assets/img/partner/1.png" alt="image"></a>
            </div>

            <div class="single-partner-item">
                <a href="#"><img src="assets/img/partner/2.png" alt="image"></a>
            </div>

            <div class="single-partner-item">
                <a href="#"><img src="assets/img/partner/3.png" alt="image"></a>
            </div>

            <div class="single-partner-item">
                <a href="#"><img src="assets/img/partner/4.png" alt="image"></a>
            </div>

            <div class="single-partner-item">
                <a href="#"><img src="assets/img/partner/5.png" alt="image"></a>
            </div>

            <div class="single-partner-item">
                <a href="#"><img src="assets/img/partner/6.png" alt="image"></a>
            </div>
        </div>
    </div>
</div> -->
<!-- End Partner Area -->

<!-- Start Features Area -->
<section class="features-area ptb-100">
    <div
        class="container"
        style="
            max-width: 100%;
            padding-left: 0px;
            padding-right: 0px;
            background-color: white;
        "
    >
        <div style="text-align: center; padding-top: 0px" class="ptb-100">
            <a href="/news-details?info=bd4" style="display: inline">
                <img
                    class="ad"
                    src="assets/img/blog/N-Cour/NTUST/NCour_NTUST_1.jpg"
                />
            </a>
        </div>

        <!-- <div id="carouselExampleIndicators" class="carousel slide" data-bs-ride="carousel">
            <div class="carousel-indicators">
                <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
                <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1" aria-label="Slide 2"></button>
            </div>
            <div class="carousel-inner">
                <div class="carousel-item active">
                    <a href="/news-details?info=event_N-Cour_Kibo">
                        <img src="assets/img/blog/N-Cour/Edm_02.jpg" class="d-block w-100" alt="..." />
                    </a>
                </div>
                <div class="carousel-item">
                    <a href="/news-details?info=event_N-Cour_Kibo_NTUST">
                        <img src="assets/img/blog/N-Cour/NTUST/NCour_NTUST_1.jpg" class="d-block w-100" alt="..." />
                    </a>
                </div>
                <div class="carousel-item">
                    <a href="/solution-details?info=企業防疫營運不中斷戰術">
                        <img src="assets/img/main/首頁廣告1800x900a.jpg" class="d-block w-100" alt="..." />
                    </a>
                </div>
            </div>
            <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                <span class="visually-hidden">Previous</span>
            </button>
            <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                <span class="visually-hidden">Next</span>
            </button>
        </div> -->
        <div class="section-title">
            <h2>下一代營運模式 NGOM</h2>
            <p>攜手，我們一起開創下一個十年計劃</p>
        </div>
        <div style="text-align: center">
            <img class="pic10" src="assets/img/main/pic_10.png" />
        </div>
        <!-- <div class="overview-box ">
            <div class="image wow zoomIn " data-wow-delay="1s ">
                <img src="assets/img/1.png " alt="image ">
            </div>

            <div class="content ">
                <h3>Make your business more competitive and sustainable.</h3>
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>

                <ul class="features-list ">
                    <li><span><i class='bx bx-check-double'></i> Influencing Sales</span></li>
                    <li><span><i class='bx bx-check-double'></i> Generating Insights</span></li>
                    <li><span><i class='bx bx-check-double'></i> Engaging Customer</span></li>
                    <li><span><i class='bx bx-check-double'></i> Boosting Operations</span></li>
                </ul>
            </div>
        </div>

        <div class="overview-box ">
            <div class="content ">
                <h3>Do what matters and we'll handle the back office routine.</h3>
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>

                <ul class="features-list ">
                    <li><span><i class='bx bx-check-double'></i> Fully Support</span></li>
                    <li><span><i class='bx bx-check-double'></i> Reliable & Cost Effective</span></li>
                    <li><span><i class='bx bx-check-double'></i> Dedicated Developers</span></li>
                    <li><span><i class='bx bx-check-double'></i> 100% Customer Satisfaction</span></li>
                </ul>
            </div>

            <div class="image wow zoomIn " data-wow-delay="1s ">
                <img src="assets/img/2.png " alt="image ">
            </div>
        </div> -->
    </div>

    <!-- <div class="rectangle-shape1 "><img src="assets/img/rectangle-shape1.png " alt="image "></div>
    <div class="rectangle-shape2 "><img src="assets/img/rectangle-shape2.png " alt="image "></div> -->
</section>
<!-- End Features Area -->

<!-- Start Serve Area -->
<section
    class="serve-area ptb-100"
    style="
        background-image: url('../../../../assets/img/main/bg.png');
        background-repeat: no-repeat;
        background-size: 100% 100%;
    "
>
    <div class="container">
        <div class="section-title">
            <h2 style="color: white">為企業再造賦能</h2>
            <p style="color: white">改變的契機，需要適用企業級的方案</p>
        </div>

        <div
            class="row"
            style="justify-content: space-between; text-align: center"
        >
            <div class="col-lg-6 col-md-4 col-sm-6 mb-5">
                <a href="/solution-details?info=so1"
                    ><img class="iconpic" src="assets/img/main/icon_pic_4.png "
                /></a>
            </div>
            <div class="col-lg-6 col-md-4 col-sm-6 mb-5">
                <a href="/solution-details?info=so2"
                    ><img class="iconpic" src="assets/img/main/icon_pic_5.png "
                /></a>
            </div>
            <div class="col-lg-6 col-md-4 col-sm-6 mb-5">
                <a href="/solution-details?info=so3"
                    ><img class="iconpic" src="assets/img/main/icon_pic_6.png "
                /></a>
            </div>
            <div class="col-lg-6 col-md-4 col-sm-6">
                <a href="/solution-details?info=so4"
                    ><img class="iconpic" src="assets/img/main/icon_pic_7.png "
                /></a>
                <!-- <a href="/solution-details?info=資料庫與資料管理DB & DW"><img src="assets/img/main/icon_pic_7.png "></a> -->
                <!-- <a href="/coming-soon"><img src="assets/img/main/icon_pic_7.png "></a> -->
            </div>
            <!-- <div class="col-lg-3 col-md-4 col-sm-6 ">
                <div class="single-serve-box ">
                    <i class="flaticon-factory "></i>
                    <h3>企業資源規劃 ERP 與 數位核心 Digital Platform</h3>
                    <a href="# "></a>
                </div>
            </div>

            <div class="col-lg-3 col-md-4 col-sm-6 ">
                <div class="single-serve-box ">
                    <i class="flaticon-hospital "></i>
                    <h3>商業智慧與預測分析BI & AI</h3>
                    <a href="# "></a>
                </div>
            </div>

            <div class="col-lg-3 col-md-4 col-sm-6 ">
                <div class="single-serve-box ">
                    <i class="flaticon-tracking "></i>
                    <h3>顧客管理 CRM與客戶體驗 CX</h3>
                    <a href="# "></a>
                </div>
            </div>

            <div class="col-lg-3 col-md-4 col-sm-6 ">
                <div class="single-serve-box ">
                    <i class="flaticon-money-bag "></i>
                    <h3>資料庫與資料管理DB & DW</h3>
                    <a href="# "></a>
                </div>
            </div> -->
        </div>
    </div>
</section>

<!-- Start Services Area -->
<section class="services-area pb-0">
    <div
        class="container"
        style="max-width: 100%; padding-right: 0px; padding-left: 0px"
    >
        <div
            class="section-title"
            style="
                margin-top: 0px;
                background-image: url(../../../../assets/img/main/bg-1.png);
                background-repeat: no-repeat;
                background-size: 100% 100%;
            "
        >
            <h2 style="color: white; padding-top: 30px">企業永續動能</h2>
            <p style="color: white; padding-bottom: 20px">
                為企業資訊升級助一臂之力
            </p>
        </div>
        <div class="row" style="margin-left: 0px; margin-right: 0px">
            <div class="col-6 col-lg-3 col-md-6 col-sm-6 mb-5">
                <a href="/service-details?info=se1"
                    ><img src="assets/img/services/icon_pic_8.png"
                /></a>
            </div>
            <div class="col-6 col-lg-3 col-md-6 col-sm-6 mb-5">
                <a href="/service-details?info=se2"
                    ><img src="assets/img/services/icon_pic_9.png"
                /></a>
            </div>
            <div class="col-6 col-lg-3 col-md-6 col-sm-6 mb-5">
                <a href="/service-details?info=se3"
                    ><img src="assets/img/services/icon_pic_10.png"
                /></a>
            </div>
            <div class="col-6 col-lg-3 col-md-6 col-sm-6 mb-5">
                <a href="/service-details?info=se4"
                    ><img src="assets/img/services/icon_pic_19.png"
                /></a>
            </div>
        </div>
        <div class="mt-3 mb-5" style="text-align: center">
            <img class="pic19" src="assets/img/main/pic_19.png" />
        </div>
        <!-- <div class="row ">

            <div class="col-lg-3 col-md-4 col-sm-6 ">
                <div class="single-serve-box ">
                    <i class="flaticon-house "></i>
                    <h3>SAP 企業流程改造</h3>
                    <a href="# "></a>
                </div>
            </div>

            <div class="col-lg-3 col-md-4 col-sm-6 ">
                <div class="single-serve-box ">
                    <i class="flaticon-box "></i>
                    <h3>軟體定義資訊中心</h3>
                    <a href="# "></a>
                </div>
            </div>

            <div class="col-lg-3 col-md-4 col-sm-6 ">
                <div class="single-serve-box ">
                    <i class="flaticon-insurance "></i>
                    <h3>企業混和雲</h3>
                    <a href="# "></a>
                </div>
            </div>

            <div class="col-lg-3 col-md-4 col-sm-6 ">
                <div class="single-serve-box ">
                    <i class="flaticon-bitcoin "></i>
                    <h3>資訊專案服務</h3>
                    <a href="# "></a>
                </div>
            </div>
        </div> -->
        <!-- <div class="section-title ">
            <h2>See wide range of our services</h2>
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
        </div>

        <div class="row ">
            <div class="col-lg-6 col-md-6 col-sm-6 ">
                <div class="single-services-box ">
                    <div class="icon ">
                        <img src="assets/img/services/plug.png " alt="image ">
                    </div>
                    <h3><a href="# ">Machine Learning</a></h3>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore.</p>
                </div>
            </div>

            <div class="col-lg-6 col-md-6 col-sm-6 ">
                <div class="single-services-box ">
                    <div class="icon ">
                        <img src="assets/img/services/drone.png " alt="image ">
                    </div>
                    <h3><a href="# ">Robotics And Drones</a></h3>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore.</p>
                </div>
            </div>

            <div class="col-lg-6 col-md-6 col-sm-6 ">
                <div class="single-services-box ">
                    <div class="icon ">
                        <img src="assets/img/services/sensor.png " alt="image ">
                    </div>
                    <h3><a href="# ">Image Processing</a></h3>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore.</p>
                </div>
            </div>

            <div class="col-lg-6 col-md-6 col-sm-6 ">
                <div class="single-services-box ">
                    <div class="icon ">
                        <img src="assets/img/services/database.png " alt="image ">
                    </div>
                    <h3><a href="# ">AI For Cloud Services</a></h3>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore.</p>
                </div>
            </div>
        </div> -->
    </div>

    <!-- <div class="services-shape "><img src="assets/img/services-shape.png " alt="image "></div> -->
</section>
<!-- End Services Area -->

<!-- <app-feedback></app-feedback> -->
<!-- End Serve Area -->
